import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { heroImage } from '../data/mock';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToPortfolio = () => {
    const element = document.getElementById('portfolio');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPartners = () => {
    const element = document.getElementById('partners');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7)), url(${heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>

      {/* Content */}
      <div className="container-artworld relative z-10 text-center">
        <div
          className={`transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`
          }>

          {/* Main Title */}
          <h1
            className="hero-title mb-6"
            style={{
              textShadow: '0 4px 20px rgba(0, 0, 0, 0.8)',
              background: 'linear-gradient(135deg, #ffffff 0%, #c0c0c0 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>

            W SHOOT
          </h1>

          {/* Subtitle */}
          <p
            className="subtitle mb-4"
            style={{
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.8)'
            }}>photographe-automobile


          </p>

          {/* Tagline */}
          <p
            className="aabody-text max-w-2xl mb-12 mx-auto !text-[#FFFFFF]"
            style={{
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.8)',
              color: 'var(--color-white)'
            }}>Capturer l'âme des machines exceptionnelles.


          </p>

          {/* CTA Buttons */}
          <div
            className="flex flex-wrap gap-4 justify-center"
            style={{ marginTop: 'var(--spacing-lg)' }}>

            <button onClick={scrollToPortfolio} className="btn-primary">
              Voir le Portfolio
            </button>
            <button onClick={scrollToContact} className="btn-accent">
              Réserver un Shooting
            </button>
            <button onClick={() => scrollToSection('partners')} className="btn-secondary">
              Découvrir nos Partenaires
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToPortfolio}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--color-white)'
        }}
        aria-label="Scroll down">

        <ChevronDown size={32} />
      </button>

      {/* Gradient Overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
          'linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.3) 100%)'
        }} />

    </section>);

};

export default HeroSection;